import React, {Fragment, useContext, useState} from 'react';
import './Terms.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {Button} from "elements/button/Button";
import {ConsentText} from "elements/consent-text/ConsentText";
import {Link} from "elements/link/Link";
import {Consent} from "compositions/consent/Consent";
import {Error} from "elements/error/Error";

export const TERMS_POPUP = 'TERMS_POPUP';

export const Terms = ({error, termsUrl, isShowMarketingConsent, currentRestaurant, onExternalLinkClick, onCancelClick, onDoneClick}) => {
	const translations = useContext(TranslationsContext);
	const [termsConsent, setTermsConsent] = useState(false);
	const [marketingConsent, setMarketingConsent] = useState(false);

	return <DrawerPopup
		title={getSafeTranslation('TermsPopup.title', translations)}
		description={
			<Fragment>
				{getSafeTranslation('TermsPopup.description', translations).replace('{restaurant}', currentRestaurant?.chainName)}
				<Link url={termsUrl}>
					{getSafeTranslation('TermsPopup.termsLinkCaption', translations)}
				</Link>
			</Fragment>
		}
		leftControl={<Button
			isText
			onClick={onCancelClick}
		>
			{getSafeTranslation('TermsPopup.cancelButtonCaption', translations)}
		</Button>}
		rightControl={<Button
			isAutoWidth
			onClick={() => onDoneClick(termsConsent, isShowMarketingConsent ? marketingConsent : undefined)}
			isDisabled={!termsConsent}
		>
			{getSafeTranslation('TermsPopup.doneButtonCaption', translations)}
		</Button>}
		onExternalLinkClick={onExternalLinkClick}
	>
		<div className="terms">
			<div className="terms__terms-consent" onClick={() => setTermsConsent(!termsConsent)}>
				<Consent
					isChecked={termsConsent}
					caption={
						<Fragment>
							<ConsentText text={getSafeTranslation('TermsPopup.termsConsentCheckboxCaption', translations)}/>
							<Link url={termsUrl}>
								{getSafeTranslation('TermsPopup.termsLinkCaption', translations)}
							</Link>
						</Fragment>

					}
				/>
			</div>
			{
				isShowMarketingConsent && (
					<div className="terms__marketing-consent" onClick={() => setMarketingConsent(!marketingConsent)}>
						<Consent
							isChecked={marketingConsent}
							caption={<ConsentText
								text={getSafeTranslation('TermsPopup.marketingConsentCheckboxCaption', translations).replace('{chainName}', currentRestaurant?.chainName)}/>}
						/>
					</div>
				)
			}
			{
				error && (<div className="terms__error">
					<Error text={error}/>
				</div>)
			}
		</div>
	</DrawerPopup>
}
